export const LOCAL_STORAGE_AUTH_KEY = 'token';
